import React, { useState } from 'react';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import Sentry from 'Integrations/Sentry';
import MessageSkeleton from 'Components/ComponentLibrary/Atoms/Skeletons/MessageSkeleton';
import DataContainer from 'Components/UI/DataContainer';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import
SystemNewRoutedThreadContent
  from 'Organisms/MessageList/MessageListItem/MessageContent/Content/MessageWithRoutedThreadContent/SystemNewRoutedThreadContent';
import
SystemStartOfRoutedThreadContent
  from 'Organisms/MessageList/MessageListItem/MessageContent/Content/MessageWithRoutedThreadContent/SystemStartOfRoutedThreadContent';
import {
  SYSTEM_START_OF_ROUTED_THREAD_MESSAGE_TYPE,
} from 'Organisms/MessageList/MessageListItem/MessageContent';
import { FDBox } from '@facet-wealth/design';

const MessageWithRoutedThreadContentContainer = ({
  messageResource,
  onLoadComplete,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [relatedMessage, setRelatedMessage] = React.useState(null);
  const { displayErrorMessage } = useSnackbarContext();
  const { selectThread } = useMessagesContext();

  const fetchRelatedMessage = async () => {
    try {
      const relatedMessageResponseResourceFromRelationship = await messageResource.withRelationship(fr.relationships.relatedMessage.name,
        async () => {
          const [relatedMessageResource] = await messageResource.relationship(fr.relationships.relatedMessage.name).link('related').get();
          return relatedMessageResource;
        },
        () => null);
      setRelatedMessage(relatedMessageResponseResourceFromRelationship);
    } catch (err) {
      Sentry.createSentryErrorLog(err);
    }
  };

  const handleRoutedThreadClick = async (rel) => {
    try {
      const [threadResource] = await rel.link('related').get();
      selectThread(threadResource);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to go to routed thread');
    }
  };

  useComponentDidMount(async () => {
    setIsLoading(true);
    await fetchRelatedMessage();
    setIsLoading(false);
    onLoadComplete();
  });

  return (
    <DataContainer
      loading={isLoading}
      skeleton={MessageSkeleton}
      component={() => (
        <FDBox>
          {
            messageResource.attr('messageType') === SYSTEM_START_OF_ROUTED_THREAD_MESSAGE_TYPE
              ? <SystemStartOfRoutedThreadContent relatedMessage={relatedMessage} messageResource={messageResource} onRoutedThreadClick={handleRoutedThreadClick} />
              : <SystemNewRoutedThreadContent relatedMessage={relatedMessage} messageResource={messageResource} onRoutedThreadClick={handleRoutedThreadClick} />
          }
        </FDBox>

      )}
    />
  );
};

MessageWithRoutedThreadContentContainer.defaultProps = {
  onLoadComplete: noop,
};

MessageWithRoutedThreadContentContainer.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default MessageWithRoutedThreadContentContainer;
